import { render, staticRenderFns } from "./rk-back.vue?vue&type=template&id=1c30a01e&"
import script from "./rk-back.vue?vue&type=script&lang=ts&"
export * from "./rk-back.vue?vue&type=script&lang=ts&"
import style0 from "./rk-back.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports